import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";

// Função para buscar as reservas

export const atualizarReservaPeriodoService = async (
  reservaId: number | null,
  periodoUsuarioId: number | null | undefined
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/reserva/${reservaId}`;
    const values = {
      periodoUsuarioId: periodoUsuarioId,
    };

    try {
      const response = await axios.patch(URL, values, {
        headers: { Authorization: Token.AuthStr },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  }

  return false;
};

export {};
